import { ApplicationApiTagTypes, ApplicationApiUrls } from "@/modules/application/common/enum";
import type {
  ICreatePeriodicalPaymentsApplicationRequest,
  IPeriodicalPaymentsApplication,
  IUpdatePeriodicalPaymentsApplicationRequest
} from "@/modules/application/common/types";
import { withIdempotency } from "@/shared/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "app/axios";

export const periodicalPaymentsApplicationApi = createApi({
  reducerPath: "periodicalPaymentsApplicationApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: [ApplicationApiTagTypes.ApplicationHistory],
  endpoints: (builder) => ({
    createPeriodicalPaymentsApplication: builder.mutation<string, ICreatePeriodicalPaymentsApplicationRequest>(
      withIdempotency<ICreatePeriodicalPaymentsApplicationRequest>(
        ApplicationApiUrls.PeriodicalPayments,
      )),
    updatePeriodicalPaymentsApplication: builder.mutation<string, IUpdatePeriodicalPaymentsApplicationRequest>(
      {
        query: ({ data, id }) => ({
          url: `${ApplicationApiUrls.PeriodicalPayments}/${id}`,
          method: "PUT",
          data,
        }),
      }),
    getPeriodicalPaymentsApplication: builder.query<IPeriodicalPaymentsApplication, {
      id: string
    }>({
      query: ({ id }) => ({
        url: `${ApplicationApiUrls.PeriodicalPayments}/${id}`,
      }),
    }),
  }),
});

export const {
  useGetPeriodicalPaymentsApplicationQuery,
  useCreatePeriodicalPaymentsApplicationMutation,
  useUpdatePeriodicalPaymentsApplicationMutation,
} = periodicalPaymentsApplicationApi;
